import { render, staticRenderFns } from "./knowledge-lite.vue?vue&type=template&id=dcdd04f2&scoped=true"
import script from "./knowledge-lite.vue?vue&type=script&lang=js"
export * from "./knowledge-lite.vue?vue&type=script&lang=js"
import style0 from "./knowledge-lite.vue?vue&type=style&index=0&id=dcdd04f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdd04f2",
  null
  
)

export default component.exports